import request from './AxiosRequest';

const browse = params =>
    request({
        url: `/Services/ListingService.svc/json/SearchListing`,
        method: 'POST',
        data: { criteria: params }
    });

const deleteListing = params =>
    request({
        url: '/Services/ListingService.svc/json/DeleteListing2',
        method: 'POST',
        data: { listing: params }
    });

const edit = params =>
    request({
        url: `/Services/ListingService.svc/json/SaveListing`,
        method: 'POST',
        data: params
    });

const ListingService = {
    browse,
    edit,
    delete: deleteListing
};

export default ListingService;
